import { Flex, Stack } from '@chakra-ui/react';
import { BsPersonXFill } from 'react-icons/bs';
// import { MdChevronRight } from 'react-icons/md';
// import { RiFolderSettingsFill } from 'react-icons/ri';
import { SecondaryButton } from '../../../components/CustomButton';
// import CustomModal from '../../../components/CustomModal';
// import AddCardModal from './AddCardModal';
// import { addCardBtnStyles } from './data';

const MoreSettings = () => {
  const handleLogout = () => {
    sessionStorage.clear();
    window.location.replace('/login');
  };
  return (
    <Stack
      bg='#F9F9F9'
      color='#9A82B8'
      borderRadius='10px'
      p='20px 20px'
      mt='15px'
    >
      {/* <Flex>
        <RiFolderSettingsFill size='1.5em' />
        <Text pl='10px'>More Settings</Text>
      </Flex>
      <Divider py='2px' orientation='horizontal' w='100%' />

      <CustomModal btnTitle={<AddCard />} buttonProps={{ ...addCardBtnStyles }}>
        <AddCardModal />
      </CustomModal> */}
      <Flex>
        <SecondaryButton
          w='150px'
          size='sm'
          leftIcon={<BsPersonXFill />}
          btnText='Logout'
          onClick={handleLogout}
        />
      </Flex>
    </Stack>
  );
};

export default MoreSettings;

// const AddCard = () => {
//   return (
//     <Flex justify='space-between' align='center'>
//       <Text fontSize='sm' py='5'>
//         Add Card
//       </Text>
//       <MdChevronRight size={20} />
//     </Flex>
//   );
// };
